<template>
  <div class="note">
    <el-dialog
      :title="$t('orderDetail.EditNote')"
      :visible.sync="dialogVisible"
      width="30%">
      <div>
        <el-input
          type="textarea"
          :rows="5"
          :placeholder="$t('orderDetail.PleaseInput')"
          v-model="remark">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('orderDetail.Cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('orderDetail.Submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      kkOrderId: '',
      dialogVisible: false,
      remark: ''
    }
  },
  methods: {
    show(kkOrderId, remark) { // 父传子
      this.dialogVisible = true
      this.kkOrderId = kkOrderId
      this.remark = remark
    },
    handleClose() {
      this.dialogVisible = false
    },
    confirm() {
      API.orderChangeRemark({
        kkOrderId: this.kkOrderId,
        data: {
          remark: this.remark
        }
      }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(this.$t('orderDetail.EditNoteSuccessTip'))
        this.handleClose()
        // 子传父
        this.$emit('EditNoteSuccess')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.note {
  /deep/ .el-dialog__header {
    padding-bottom: 0;
  }
}
</style>
